import { createAction } from '@reduxjs/toolkit';

import { AdminProductsSortBy } from '../../../api/admin-products/types';

export const setAdminProductsSortBy = createAction<AdminProductsSortBy | undefined>('SET_ADMIN_PRODUCTS_SORT_BY');

export const setAdminProductsPage = createAction<number>('SET_ADMIN_PRODUCTS_PAGE');

export const setAdminProductsKeyword = createAction<{ keyword?: string }>('SET_ADMIN_PRODUCTS_KEYWORD');
